export default __webpack_public_path__ + "static/media/7SD503.caa1073b.png";